const category: Record<string, string | Record<string, string>> = {
    categoryListTitle: 'Categories of initiatives',
    fields: {
        form: 'Subject`s Form',
        process: 'Subject`s LC',
    },
};

export default category;
